import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type TemplateInstructionResponse = {
  instructions: string | null;
};

type SaveTemplateInstructionInput = {
  templateId: string;
  instructions: string;
};

export function useSaveTemplateInstruction() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isSaving } = useMutation<
    { data: TemplateInstructionResponse },
    Error,
    SaveTemplateInstructionInput
  >({
    mutationFn: ({ templateId, instructions }) =>
      api.put<TemplateInstructionResponse>(`templates/${templateId}/instructions`, {
        instructions,
      }),
    onSuccess: (_data, { templateId }) => {
      queryClient.invalidateQueries({ queryKey: ['templates', templateId, 'instructions'] });
    },
  });

  const saveInstruction = async (templateId: string, instructions: string) =>
    mutateAsync({ templateId, instructions });

  return {
    saveInstruction,
    isSaving,
  };
}
